import React, { useState } from "react"
import { connect } from "react-redux"
import { Button, Image, Popup } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import LocationIconBlack from "../../../images/location_vector_black.svg"
import InfoIcon from "../../../images/info-Icon.svg"

const SelectedShop = (props) => {
  const { user, t, shop } = props
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => setIsOpen(true)
  const handleClose = () => setIsOpen(false)

  return (
    <div className="Select-shop-card">
      <p className="shop-info">
        <Image src={LocationIconBlack} /> Tire delivery and installation location
      </p>
      <div className="shop-name">{shop.name}</div>
      <div className="shop-address">{shop.address_line1}</div>
      <div className="shop-address">
        {shop.city}, {shop.state} {shop.zip}
      </div>
      <div className="shop-service">
        <span>Tire Install </span>{" "}
        <span>
          <b className="total">$0.00</b> Paid in full on eBay{" "}
          <Popup
            className="shop-info-popup"
            trigger={<Image src={InfoIcon} onClick={handleOpen} />}
            open={isOpen}
            onClose={handleClose}
            inverted
            position="bottom right"
            on="click"
          >
            <div>
              Includes tire mount/dismount, disposal, install, balance, TPMS Service Valve Kit, and
              valve replacement.
            </div>
            <Button basic className="shop-info-button" onClick={handleClose}>
              Got it
            </Button>
          </Popup>{" "}
        </span>
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  let user = state.user || {}
  return {
    user: user
  }
}

export default connect(mapStateToProps, {})(withTranslation("vehicleDetails")(SelectedShop))
